import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', _vm._g({}, _vm.actions.length > 0 || _vm.attributes.length > 0 ? {
    click: () => _vm.showPopup = true
  } : {}), [_c(VIcon, {
    attrs: {
      "slot": "marker",
      "color": _vm.markerColor
    },
    slot: "marker"
  }, [_vm._v("fa fa-" + _vm._s(_vm.twin.data.faIcon || 'location-dot'))]), _c(VBottomSheet, {
    attrs: {
      "inset": "",
      "max-width": "500"
    },
    model: {
      value: _vm.showPopup,
      callback: function ($$v) {
        _vm.showPopup = $$v;
      },
      expression: "showPopup"
    }
  }, [_c(VCard, [_c(VRow, [_c(VCol, {
    staticStyle: {
      "padding-block": "0"
    }
  }, [_vm.get(_vm.widget, 'twinMapOptions.popupTitle') ? _c(VCardTitle, [_vm._v("\n            " + _vm._s(_vm.template(_vm.get(_vm.widget, 'twinMapOptions.popupTitle'))) + "\n          ")]) : _vm._e()], 1), _c(VCol, {
    staticStyle: {
      "padding-block": "0"
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-button', {
    attrs: {
      "color": "error",
      "icon": "",
      "prepend-icon": "fal fa-xmark"
    },
    on: {
      "click": function ($event) {
        _vm.showPopup = false;
      }
    }
  })], 1)], 1), _vm.attributes.length > 0 || _vm.actions.length > 0 ? _c(VDivider, {
    staticStyle: {
      "margin-inline": "0 !important"
    }
  }) : _vm._e(), _c(VList, _vm._l(_vm.attributes, function (attribute, index) {
    return _c(VListItem, {
      key: `attribute-${index}`,
      attrs: {
        "two-line": ""
      }
    }, [_c(VListItemContent, [_c(VListItemSubtitle, [_vm._v(_vm._s(_vm.getAttributeLabel(attribute)))]), _c(VListItemTitle, [_vm._v(_vm._s(_vm.getAttributeValue(attribute)))])], 1)], 1);
  }), 1), _c(VRow, {
    staticStyle: {
      "max-width": "100%",
      "margin": "0"
    }
  }, _vm._l(_vm.actions, function (action, index) {
    return _c(VCol, {
      key: `action-${index}`,
      attrs: {
        "cols": "auto"
      }
    }, [_c('core-button', {
      attrs: {
        "single-line": false,
        "color": _vm.color,
        "block": ""
      },
      on: {
        "click": function ($event) {
          return _vm.onActionClick(action, _vm.twin);
        }
      }
    }, [action.action === 'twin.open' ? _c(VIcon, {
      attrs: {
        "left": ""
      }
    }, [_vm._v("fal fa-dice-d8")]) : _vm._e(), action.action === 'url.open' ? _c(VIcon, {
      attrs: {
        "left": ""
      }
    }, [_vm._v("\n              " + _vm._s(_vm.get(action, 'parameters.openInNewTab', false) ? 'fal fa-arrow-up-right-from-square' : 'fal fa-link') + "\n            ")]) : _vm._e(), action.action === 'dashboard.open' ? _c(VIcon, {
      attrs: {
        "left": ""
      }
    }, [_vm._v("fal fa-user-chart")]) : _vm._e(), _vm._v("\n\n            " + _vm._s(_vm.template(action.label)) + "\n          ")], 1)], 1);
  }), 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };